const expertiseItems = [
  {
    icon: "ri-ruler-2-line",
    title: "足計測",
    desc: "長さ・幅・甲の高さ・アーチを細かく計測。数値だけでなく、足の特徴を見ます。",
  },
  {
    icon: "ri-body-scan-line",
    title: "足骨格の確認",
    desc: "外反母趾・偏平足・ハイアーチなど、骨格レベルで合う靴の条件を見極めます。",
  },
  {
    icon: "ri-scissors-2-line",
    title: "細幅・特殊サイズ対応",
    desc: "AA〜B幅の細幅展開、22cm〜を含む小さいサイズも豊富に取り揃えています。",
  },
  {
    icon: "ri-swap-line",
    title: "丁寧なフィッティング",
    desc: "試し履きで終わらず、歩いた感覚・サイズのズレ・痛みの箇所まで確認します。",
  },
  {
    icon: "ri-tools-line",
    title: "インソール・微調整",
    desc: "既製品に合わせたインソールや中敷き調整で、靴の履き心地を最適化します。",
  },
  {
    icon: "ri-shield-check-line",
    title: "アフターサポート",
    desc: "購入後も相談できる環境。LINEや再来店でのアフターフォローを行っています。",
  },
];

export default function ExpertiseSection() {
  return (
    <section className="bg-white py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left text */}
          <div>
            <p
              className="text-[#B8895A] text-xs tracking-widest mb-4 uppercase"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              Expertise
            </p>
            <h2
              className="text-3xl md:text-4xl font-bold text-[#1C1917] leading-snug mb-6"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              "感覚"ではなく、
              <br />
              足に合わせて選ぶ。
            </h2>
            <p
              className="text-[#78716C] text-sm leading-loose mb-8"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              見た目だけでは分からない、
              <br />
              <strong className="text-[#44403C] font-medium">"履きやすさの理由"</strong>を見ています。
              <br />
              <br />
              専門機器があるから、ではありません。
              足の特徴を知って、靴選びに活かすから、
              綺麗に履ける理由があるのです。
            </p>

            {/* Quote */}
            <div className="border-l-2 border-[#B8895A] pl-6 py-2">
              <p
                className="text-[#1C1917] text-base font-medium leading-loose"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                "お客様の足と、
                <br />
                お客様の好きを両方知ること。
                <br />
                それが私たちの仕事です。"
              </p>
            </div>

            {/* Image */}
            <div className="mt-10 rounded-2xl overflow-hidden w-full h-48 md:h-56">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20Japanese%20shoe%20boutique%20interior%20with%20warm%20wooden%20shelves%20displaying%20nude%20and%20neutral%20tone%20pumps%2C%20soft%20ambient%20lighting%2C%20cream%20and%20natural%20wood%20interior%20design%2C%20sophisticated%20retail%20atmosphere%2C%20no%20people%2C%20warm%20and%20inviting&width=800&height=450&seq=expertise1&orientation=landscape"
                alt="レディースキッドの店内"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right expertise grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {expertiseItems.map((item, i) => (
              <div
                key={i}
                className="bg-[#FAFAF8] rounded-2xl p-5 border border-[#F0EBE3] hover:border-[#E8C99A]/50 transition-all duration-200 group"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-white rounded-xl border border-[#F0EBE3] mb-4 group-hover:border-[#E8C99A]/50 transition-colors">
                  <i className={`${item.icon} text-[#B8895A] text-lg`} />
                </div>
                <h3
                  className="text-[#1C1917] text-sm font-bold mb-2"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {item.title}
                </h3>
                <p
                  className="text-[#78716C] text-xs leading-loose"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}